export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

export const fmtDate = (d) => {
  if (!d) return "";
  const [y, m, day] = d.slice(0, 10).split("-");
  return `${m}/${day}/${y}`;
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const thisYear = () => new Date().getFullYear();

export const yearOptions = () => {
  const y = thisYear() + 5;
  return Array.from({ length: y - 2020 + 1 }, (_, i) => String(y - i));
};

export const slug = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const PROGRESS_FIELDS = [
  { key: "ri_jar", mh: "Ri-Jar", en: "People attending church each Sunday" },
  { key: "active_members", mh: "Active Members", en: "Total active members" },
  { key: "ukwelok", mh: "Ukwelok", en: "People who came to Jesus" },
  { key: "aje", mh: "Aje", en: "Children dedicated to God (prayed over by pastor)" },
  { key: "baptise_ilo_dren", mh: "Baptise ilo Dren", en: "People baptized in water" },
  { key: "ilok_ilo_kur", mh: "Ilok ilo Kur eo an Iroij", en: "People who have passed away" },
  { key: "jete_prayer_cell", mh: "Jete Prayer Cell", en: "Number of group / prayer cells" },
];

export const GOALS_FIELD = { key: "ta_menin_kotobar", mh: "Ta menin Kotobar ko", en: "Church goals" };
